<template>
    <v-card>
        <v-toolbar dark color="secondary" class="white--text" dense>
            <v-spacer></v-spacer>
            <v-toolbar-title>
                Expense mail
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-container grid-list-xs fluid>
            <v-row class="justify-center">
                <v-col cols="6">
                    <v-combobox  v-model="period" :items="periods" :item-text="'Period'" auto-select-first @click:prepend="LoadMails"
                        label="Select a Period" hide-details dense @change="LoadMails" :prepend-icon="'mdi-refresh'"></v-combobox>
                </v-col>
            </v-row>

            <v-container grid-list-xs>
                <v-row>
                    <v-col cols="3">
                        <v-combobox label="Filter By Truck" dense hide-details :items="filterCompany" auto-select-first
                            v-model="company"></v-combobox>
                    </v-col>
                    <v-col cols="1">
                        <v-checkbox label="All" dense  hide-details :v-model="all" :value="all" @change="selectAll"></v-checkbox>
                    </v-col>
                    <v-col>

                    <v-btn color="primary" class="float-right" @click="sendMail()">Send Mail</v-btn>
                    </v-col>
                </v-row>
                <v-data-iterator :items="filteredItems" :page="page" :items-per-page.sync="itemsPerPage"
                    :rows-per-page-items="1">
                    <template v-slot:default="props">
                        <v-row>
                            <v-col v-for="(itm, idx) in props.items" v-bind:key="'row' + idx" sm="6" md="4" lg="3">
                                <v-simple-table dense>
                                    <thead>
                                        <tr>
                                            <th colspan="4" style="background: #4f83cc;" class="text-center">
                                                <v-checkbox dark :label="itm.Truck" v-model="itm.CheckMail" :value="itm.CheckMail"></v-checkbox>
                                            </th>
                                        </tr>
                                        <tr class="text-center">
                                            <td colspan="4">{{ itm.Company }}</td>
                                        </tr>
                                       <tr></tr>
                                        <tr class="text-center">
                                            <td colspan="4">{{ period['EfectiveDateStart'] }} / {{ period['EfectiveDateEnd']
                                            }}</td>
                                        </tr>
                                        <tr></tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th colspan="4" class="text-center">Revenue</th>
                                        </tr>
                                        <tr v-for="(it, itIdx) in itm.payroll" v-bind:key="'Rev' + itIdx">
                                            <td v-if="it.TruckID == itm.TruckID"  colspan="3" class="text-right">{{it.PayDate + ' - ' + it.PayStId }}</td>
                                            <td v-if="it.TruckID == itm.TruckID" colspan="1" class="text-left">$ {{
                                                Number(it.Total).toFixed(2).toLocaleString('es-ES') }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-right"><strong>Total Revenue</strong> </td>
                                            <td colspan="1" class="text-left">
                                                <strong>
                                                   $ {{Number(itm.PayTotal).toFixed(2).toLocaleString('es-ES')  }}
                                                </strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                                <v-simple-table dense>
                                        <thead>
                                            <tr>
                                                <th colspan="4" class="text-center">Expenses</th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(it, itIdx) in itm.payroll" v-bind:key="'Exp' + itIdx">
                                            <tr v-if="it.fuel != [] && it.TruckID == itm.TruckID || it.fuel.length != null && it.TruckID == itm.TruckID" >
                                                <td colspan="3" class="text-right">{{ it.PayDate + ' - '  }}  {{ it.fuel[0] == undefined ? '' : it.fuel[0].Stid }}</td>
                                                <td colspan="1" class="text-left">$
                                                    {{it.fuel[0] == undefined ? '' : Number(it.fuel[0].Total).toFixed(2).toLocaleString('es-ES') }}
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody v-for="(it, id) in itm.payroll" v-bind:key="'Ext' + id">
                                            <template v-if="it.ext_expense != []">
                                                <tr v-for="(i, ix) in it['ext_expense']" v-bind:key="'ExtType' + ix">
                                                    <td v-if="i.TruckId == itm.TruckID" colspan="3" class="text-right">
                                                        {{it.Specification == null ?  i.ExtExpenseType : i.ExtExpenseType  + ' - ' + it.Specification}}</td>
                                                    <td v-if="i.TruckId == itm.TruckID" colspan="1" class="text-left">$ {{
                                                        Number(i.Total).toFixed(2).toLocaleString('es-ES') }}</td>
                                                </tr>
                                            </template>
                                        </tbody>
                                        <tr>
                                            <td colspan="3" class="text-right pr-5"><strong>Total Expenses</strong></td>
                                            <td colspan="1" class="text-left">
                                                <strong>
                                                    $ {{ Number(itm.TotalExp).toFixed(2).toLocaleString('es-ES')  }}
                                                </strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-right pr-5"><strong>Total</strong></td>
                                            <td colspan="1" class="text-left">
                                                <strong>
                                                    $ {{ Number(itm.Total).toFixed(2).toLocaleString('es-ES')  }}
                                                </strong>
                                            </td>
                                        </tr>

                                        <!-- <tr>
                                            <td colspan="3" class="text-right">Total Expense </td>
                                            <td colspan="1" class="text-left">{{
                                                Number(itm.PayTotal + itm.TotalFuel + itm.ExtTotal).toFixed(2).toLocaleString('es-ES')  }}</td>
                                        </tr> -->
                                        <!-- <tr v-if="itm.fuel.length > 0">
                                            <td colspan="3" class="text-right">{{ itm.fuel[0].Stid }}</td>
                                            <td colspan="1" class="text-left">$ {{
                                                Number(itm.fuel[0].Total).toFixed(2).toLocaleString('es-ES') }}
                                            </td>
                                        </tr> -->
                                        <!----

                                        <tr>
                                            <th colspan="3" class="text-right">Net Pay</th>
                                            <th colspan="1" class="text-left">{{
                                                Number(itm.SUMTotals).toFixed(2).toLocaleString('es-ES') }}</th>
                                        </tr> -->
                                </v-simple-table>


                            </v-col>
                        </v-row>
                    </template>
                </v-data-iterator>
            </v-container>
        </v-container>
    </v-card>
</template>
<script>
import axios from "axios";
export default {
    data: function () {
        return {
            StartDate: null,
            EndDate: null,
            period: null,
            periods: null,
            contentRows: [],
            page: 1,
            itemsPerPage: 4,
            company: null,
            filterCompany: null,
            all: false
        }
    },
    mounted() {
        this.LoadPeriods();
    },
    computed: {
        filteredItems: function () {
            return this.contentRows.filter(i => {
                return !this.company || i.Company == this.company;
            });
        },
    },
    methods: {
        selectAll: function () {
            this.all = !this.all;
            this.contentRows.forEach(element => {
                element.CheckMail = this.all;
            });
        },
        LoadPeriods: function () {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('ext-expense/get/periods', )
                .then(response => {
                    this.periods = response.data;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        eliminarDuplicados: function (arr) {
            const uniqueElements = new Set();
            return arr.filter(item => {
                const serializedItem = JSON.stringify(item);
                if (!uniqueElements.has(serializedItem)) {
                    uniqueElements.add(serializedItem);
                    return true;
                }
                return false;
            });
        },
        LoadMails: function () {
            var str = this.$store;
            str.state.isLoading = true;
            this.showAdd = true;
            var parms = {};
            parms.StartDate = this.period['EfectiveDateStart'];
            parms.EndDate = this.period['EfectiveDateEnd'];

            axios
                .post('ext-expenses/mail', parms, )
                .then(response => {
                    this.contentRows = response.data;
                    const truck = response.data.map(x => {
                        return x.Company;
                    });
                    this.filterCompany = this.eliminarDuplicados(truck);
                    for (let i = 0; i < this.contentRows.length; i++) {
                        const element = this.contentRows[i];
                        if (Array.isArray(element['payroll'])) {
                            console.log('Is Array');
                            element['payroll'] = element['payroll'].filter(y => y.TruckID == element['TruckID']);
                        }else{
                            console.log('Is Objet');
                            const payroll = element['payroll'];
                            element['payroll'] = [];
                            element['payroll'].push(payroll);
                        }

                    }
                    console.log(this.contentRows);
                    console.log(this.filterCompany);
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        sendMail:async function(){
            var str = this.$store;
            var parms = {};
            var companys = await this.contentRows.filter(x => {
               return x.CheckMail === true;
            }).map(y => {
                return {
                    Company: y.Company,
                    CompanyId: y.CompanyId
                };
            });
            var company = await this.eliminarDuplicados(companys);
            console.log(company);
            var Mail = [];
           await company.forEach(async x => {
                var array = {
                    CompanyId: x.CompanyId,
                    Company:x.Company,
                    Range: this.period.Period,
                    Charges : await this.contentRows.filter(y => {
                        return y.CheckMail === true && x.CompanyId === y.CompanyId;
                    })
                }
                Mail.push(array);
            });
            parms.Mail = Mail;
            axios
                .post('ext-expenses/send/mail', parms, )
                .then(response => {
                    console.log(response.data);
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        }
    }
}
</script>